export function modalAction() {
  if (document.querySelector('.js-modalView')) {
    const body = document.querySelector('body');
    const modalViewEle = document.querySelector('.js-modalView');
    const modalTrigger = document.querySelectorAll('.js-modalTrigger');
    const modalTriggerList = Array.prototype.slice.call(modalTrigger, 0);
    const modalFigureSet = document.querySelector('.js-modalFigureSet');
    const modalRoomSet = document.querySelector('.js-modalRoomSet');
    const modalOverlay = document.querySelector('.js-modalOverlay');
    const modalClose = document.querySelector('.js-modalClose');

    let selectImg = '';
    let selectRoom = '';

    /** 選択した画像をモーダルで表示（.c-card） */
    modalTriggerList.forEach((targetBox) => {
      targetBox.addEventListener('click', () => {
        if (targetBox.classList.contains('is-room')) {
          selectRoom = targetBox.lastElementChild.innerHTML;
          modalRoomSet.innerHTML = selectRoom;
        } else {
          selectImg = targetBox.firstElementChild.getAttribute('src');
          modalFigureSet.setAttribute('src', selectImg);
          modalFigureSet.classList.add('is-view');
        }

        body.classList.add('is-fixed');
        modalOverlay.classList.add('is-view');
        modalViewEle.classList.add('is-view');
      });
    });

    /** modal close */
    if (document.querySelector('.js-modalClose')) {
      modalClose.addEventListener('click', () => {
        body.classList.remove('is-fixed');
        modalOverlay.classList.remove('is-view');
        modalViewEle.classList.remove('is-view');
        modalFigureSet.classList.remove('is-view');
        modalFigureSet.setAttribute('src', '');
        modalRoomSet.firstElementChild.remove();
      });
    }
  }
}
